import type { MappingData } from 'api/fetchCommon';
import type { CalculationSummary } from 'api/submitRtool';
import { getMappingLabel } from 'utils/mappingLabel';

export type CalcConditionResult = { succeeded: string[]; missing_data: string[]; failed: string[] };

// condition_id は `<phenomenon_id>-<drive_mode_id>`（値域はいずれもハイフンを含まないため split('-') で確定）。
export const buildConditionLabel = (conditionId: string, mapping: MappingData | null): string => {
    const [phenomenonId, driveModeId] = conditionId.split('-');
    return `${getMappingLabel(mapping, 'drive_mode_id', driveModeId)} × ${getMappingLabel(mapping, 'phenomenon_id', phenomenonId)}`;
};

// R 側計算 API（calc/gear 単位一括呼び出し）の 4 分類サマリから表示用ラベルへ変換する。
// succeeded / missing_data / failed は条件一覧を表示、skipped_no_data のみ非表示（issue #28）。
// 付随詳細（reason / missing_dataset_ids）は画面に出さないが、原因調査のため
// 開発者向けログには残す（ユーザー向け文言と開発者向け詳細の分離方針）。
export const buildCalcConditionResult = (
    summary: CalculationSummary,
    mapping: MappingData | null,
): CalcConditionResult => {
    if (summary.failed.length > 0 || summary.missing_data.length > 0) {
        console.error('計算サマリ詳細:', {
            failed: summary.failed,
            missing_data: summary.missing_data,
        });
    }
    return {
        succeeded: summary.succeeded.map((conditionId) => buildConditionLabel(conditionId, mapping)),
        missing_data: summary.missing_data.map(({ condition_id }) => buildConditionLabel(condition_id, mapping)),
        failed: summary.failed.map(({ condition_id }) => buildConditionLabel(condition_id, mapping)),
    };
};
